<template>
  <input v-model="inputValue" type="text" autocomplete="false" @keyup="delayedEmit($event.target.value)">
</template>

<script setup>

import {ref, watch} from "vue";

// Props
const props = defineProps({
  modelValue: String,
  delay: {
    type: Number,
    default: 1000
  }
});

// Events
const emit = defineEmits(['update:modelValue']);

// Reactive data
const inputValue = ref(props.modelValue);

// Watchers
watch(() => props.modelValue, newValue => {
  inputValue.value = newValue;
});

const keyup = () => {
  alert('keyup');
}

let delayTimeout;

const delayedEmit = value => {
  clearTimeout(delayTimeout);
  delayTimeout = setTimeout(() => {
    emit('update:modelValue', value);
  }, props.delay);
}

</script>

<style scoped>

</style>